export default "__VITE_ASSET__C1o8a9Qk__"